import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

export default function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: "auto",
          color:"#fff",
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#003087"
              : theme.palette.grey[800],
          // zIndex: 9999,
          height: "45px"
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="body1">
          
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
